export const REQUEST_FIELD_DETAILS = 'REQUEST_FIELD_DETAILS';
export const RECEIVE_FIELD_DETAILS = 'RECEIVE_FIELD_DETAILS';
export const RECEIVE_COUNTRY_FEATURES = 'RECEIVE_COUNTRY_FEATURES';
export const RECEIVE_FIELD_FEATURES = 'RECEIVE_FIELD_FEATURES';
export const FAILURE_FIELD_DATA = 'FAILURE_FIELD_DATA';

export const REQUEST_CURRENT_CONDITIONS = 'REQUEST_CURRENT_CONDITIONS';
export const REQUEST_CURRENT_CONDITIONS_BY_LOCATION = 'REQUEST_CURRENT_CONDITIONS_BY_LOCATION';
export const RECEIVE_CURRENT_CONDITIONS = 'RECEIVE_CURRENT_CONDITIONS';
export const REQUEST_HOURLY_CONDITION = 'REQUEST_HOURLY_CONDITION';
export const REQUEST_HOURLY_CONDITION_BY_LOCATION = 'REQUEST_HOURLY_CONDITION_BY_LOCATION';
export const RECEIVE_HOURLY_CONDITIONS = 'RECEIVE_HOURLY_CONDITIONS';
export const RECEIVE_DAILY_CONDITIONS = 'RECEIVE_DAILY_CONDITIONS';
export const REQUEST_DAILY_CONDITIONS = 'REQUEST_DAILY_CONDITIONS';
export const REQUEST_DAILY_CONDITIONS_BY_LOCATION = 'REQUEST_DAILY_CONDITIONS_BY_LOCATION';
export const FAILURE_WEATHER_CONDITIONS = 'FAILURE_WEATHER_CONDITIONS';

export const REQUEST_PAST_WEATHER = 'REQUEST_PAST_WEATHER';
export const RECEIVE_PAST_WEATHER = 'RECEIVE_PAST_WEATHER';
export const UPDATE_PAST_WEATHER_VALUE = 'UPDATE_PAST_WEATHER_VALUE';
export const RECEIVE_HISTORICAL_WEATHER = 'RECEIVE_HISTORICAL_WEATHER';
export const CLEAR_HISTORICAL_DATA = 'CLEAR_HISTORICAL_DATA';
export const TOGGLE_PRECIPITATION_HELP = 'TOGGLE_PRECIPITATION_HELP';
export const TOGGLE_TEMPERATURE_HELP = 'TOGGLE_TEMPERATURE_HELP';
export const REQUEST_HISTORICAL_WEATHER = 'REQUEST_HISTORICAL_WEATHER';
export const FAILURE_WEATHER = 'FAILURE_WEATHER';
export const FAILURE_PAST_WEATHER = 'FAILURE_PAST_WEATHER';
export const CLEAR_PAST_WEATHER_FAILURE = 'CLEAR_PAST_WEATHER_FAILURE';

export const REQUEST_CURRENT_USER_DETAILS = 'REQUEST_CURRENT_USER_DETAILS';
export const RECEIVE_CURRENT_USER_DETAILS = 'RECEIVE_CURRENT_USER_DETAILS';
export const REQUEST_CURRENT_USER_DETAILS_FAILURE =
  'REQUEST_CURRENT_USER_DETAILS_FAILURE';

export const TRACK_WEATHER_EVENT = 'TRACK_WEATHER_EVENT';

export const RECEIVE_FEATURES = 'RECEIVE_FEATURES';

export const RESET_STATE = 'RESET_STATE'
